import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { NotificationInstance } from "@redotech/redo-web/notification-provider";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";

const SkippedShipmentsNotificationContent = memo(
  function SkippedShipmentsNotificationContent({
    skippedGroups,
    dismiss,
  }: {
    skippedGroups: readonly FulfillmentGroupData[];
    dismiss: () => void;
  }) {
    const [modalOpen, setModalOpen] = useState(false);

    return (
      <>
        <Text fontSize="sm" fontWeight="medium" textColor="secondary">
          {`${skippedGroups.length} label${skippedGroups.length === 1 ? "" : "s"} were not purchased. `}
          <Text
            as="span"
            fontSize="sm"
            fontWeight="medium"
            onClick={() => setModalOpen(true)}
            style={{ cursor: "pointer", textDecoration: "underline" }}
            textColor="secondary"
          >
            View orders
          </Text>
        </Text>
        <RedoModal
          isOpen={modalOpen}
          modalSize="sm"
          onModalCloseRequested={() => {
            setModalOpen(false);
            dismiss();
          }}
          primaryButton={{
            onClick: () => {
              setModalOpen(false);
              dismiss();
            },
            text: "Close",
          }}
          subtitle="The following orders could not get a rate. You will not be able to purchase labels for these orders until these errors are resolved."
          title="Order details"
        >
          <Flex dir="column" gap="lg">
            {skippedGroups.map((group) =>
              group.orders.map((order) => (
                <Text fontSize="sm" key={order.id} textColor="error">
                  &bull; {order.name}
                </Text>
              )),
            )}
          </Flex>
        </RedoModal>
      </>
    );
  },
);

export function getSkippedShipmentsNotificationInstance(
  purchasedGroups: readonly FulfillmentGroupData[],
  skippedGroups: readonly FulfillmentGroupData[],
): NotificationInstance {
  return {
    title: `${purchasedGroups.length} label${purchasedGroups.length === 1 ? "" : "s"} purchased`,
    children: (dismiss) => (
      <SkippedShipmentsNotificationContent
        dismiss={dismiss}
        skippedGroups={skippedGroups}
      />
    ),
    onDismiss(): void | Promise<void> {
      // Notification will be dismissed
    },
  };
}
